import PropTypes from 'prop-types';
import React from 'react';

function GalleryImage({ src, alt, handleClick }: { src: string; alt: string; handleClick?: () => void }) {
    return (
        <img
            src={src}
            alt={alt}
            className="w-full h-full object-cover rounded-xl cursor-pointer"
            onClick={handleClick}
        />
    );
}

GalleryImage.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
};

export default GalleryImage;
